import * as React from 'react'

export const CheckmarkIcon = (props: any) =>
<svg xmlns="http://www.w3.org/2000/svg" className="checkmark-icon" viewBox="0 0 27 27">
    <g transform="translate(-1257 -631)">
        <circle cx="13.5" cy="13.5" r="13.5" fill="#72cac2" transform="translate(1257 631)"/>
        <path fill="#fff" fillRule="evenodd" d="M13.683 5.059a1.045 1.045 0 1 1 1.493 1.464l-5.565 6.955a1.046 1.046 0 0 1-1.506.028L4.418 9.818A1.046 1.046 0 1 1 5.9 8.34l2.919 2.918L13.66 5.09a.329.329 0 0 1 .028-.031z" transform="translate(1260.915 635.692)"/>
    </g>
</svg>
